import { useEffect, useMemo, useState } from 'react';
import { getContainer } from '@framework/di/getContainer';
import DictionaryRepository from '@/creditflowresearch/infrastructure/repository/DictionaryRepository';
import { useCorporateBondScreenerSidebarFilterContext } from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilterContext';
import useCheckboxFilter from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/hooks/useCheckboxFilter';
import useAbsoluteFilter from '@/creditflowresearch/application/BondScreener/useAbsoluteFilter';
import mapToCheckboxOptions from '@/creditflowresearch/application/BondScreener/mapToCheckboxOptions';

const useRatingsSection = () => {
  const { filters } = useCorporateBondScreenerSidebarFilterContext();
  const repository = getContainer().get(DictionaryRepository);
  const [dictionary, setDictionary] = useState([]);

  useEffect(() => {
    const loadDictionary = async () => {
      setDictionary(await repository.getRatingGroups());
    };
    loadDictionary();
  }, []);

  const items = useMemo(
    () => mapToCheckboxOptions(filters?.ratingGroupIds, dictionary, (item) => item.abbreviation),
  [dictionary, filters?.ratingGroupIds]);

  const checkboxFilter = useCheckboxFilter({ filterKey: 'includedRatingGroupIds', items });
  const allValues = useMemo(() => items.map((item) => item.value), [items]);

  const { isAbsolute, onToggleAbsolute, toggle, toggleAll } = useAbsoluteFilter({
    includedKey: 'includedRatingGroupIds',
    excludedKey: 'excludedRatingGroupIds',
    allValues,
    toggle: checkboxFilter.toggle,
    toggleAll: checkboxFilter.toggleAll,
    useFilterContext: useCorporateBondScreenerSidebarFilterContext,
  });

  return { ...checkboxFilter, toggle, toggleAll, isAbsolute, onToggleAbsolute };
};

export default useRatingsSection;
